 <div class="itb-feedback-container">
    <div class="feedback-browser">
      <div class="browser-top">
        <strong class="header-text"
          ><itb-text
            [className]="'text-default'"
            [text]="'Email Template'"
          ></itb-text
        ></strong>
        <div class="browser-icons">
          <div class="red"></div>
          <div class="yellow"></div>
          <div class="green"></div>
        </div>
      </div>
      <div class="browser-body">
        <strong class="header-text">
          <itb-text [className]="'text-default'" [text]="'Thank you for your feedback'"></itb-text>
        </strong>
      
        <div *ngIf="editText=== false">
          <p class="text-default">
            <itb-text [className]="'text-default'" [text]="tempTemplateField"></itb-text>
            <itb-icon [hidden]="isDisabled" [tooltipText]="'Update'" [className]="'edit'" (onClickHandler)="editCopyrightTextFunc()"></itb-icon>
          </p>
        </div>
        <div class="text-edit" *ngIf="editText">
          <div>
            <form class="form-horizontal">
              <itb-textarea [isReactive]=false  [rows]="'10'" [placeholder]="" [value]="tempTemplateField"
                [maxlength]="templateMaxLength" (onTextChangeHandler)="onTemplateChange($event)"></itb-textarea>
            </form>
          </div>
          <div class="edit-icon">
            <itb-icon [hidden]="tempTemplateField.trim().length === 0" [tooltipText]="'Save'" [className]="'save'" (onClickHandler)="onChange()"></itb-icon>
            <itb-icon [tooltipText]="'Cancel'" [className]="'cross'" (onClickHandler)="editCopyrightTextFunc()"></itb-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  